import { z } from 'zod';
/**
 * Die Antwortverträge der Anmeldestrecke — `V-vertrag3` (2026-08-29).
 *
 * `apps/api/src/auth/auth.controller.ts` und `apps/api/src/auth/auth.service.ts`
 * führten `StageResponse` und `TotpEnrollment` bislang als eigene, nicht mit
 * `@fameacc/contracts` verbundene Formen — der OpenAPI-Erzeuger blieb an
 * `POST /api/v1/auth/login`, `.../password`, `.../totp/enroll` und
 * `.../totp/verify` deshalb `[UNGEKLÄRT]` (`schemaNameZuTyp`,
 * `apps/api/src/openapi/aufloesung.ts`). Kein Eingabevertrag entsteht hier:
 * `loginSchema`/`passwordSchema`/`totpSchema` bleiben Anfrageform des
 * Controllers, weil ihre Prüfung dort und nicht im Vertragspaket steht.
 */
/**
 * Die drei Zustände der Vor-Session-Kette —
 * `apps/api/src/auth/pre-session.ts`, `PreSessionState`.
 */
export const preSessionStateSchema = z.enum([
    'awaiting_password_change',
    'awaiting_totp_enroll',
    'awaiting_totp',
]);
/**
 * Antwort der Anmeldeendpunkte: entweder ein offener Schritt oder
 * «angemeldet» — `POST /api/v1/auth/login`, `.../password`,
 * `.../totp/verify`.
 */
export const stageResponseSchema = z
    .object({
    status: z.enum(['pre-session', 'authenticated']),
    /** Nur gesetzt, solange `status` `pre-session` ist. */
    state: preSessionStateSchema.optional(),
})
    .strict();
/**
 * Was die TOTP-Einrichtung zurückgibt — einmalig und nie wieder.
 * `POST /api/v1/auth/totp/enroll`.
 */
export const totpEnrollmentSchema = z
    .object({
    /** Das Geheimnis in base32, zum Abtippen, falls die Kamera streikt. */
    secret: z.string(),
    /** Die `otpauth`-Adresse. */
    uri: z.string(),
    /** Derselbe Inhalt als QR-Code, als Daten-URL. */
    qrDataUrl: z.string(),
})
    .strict();
/**
 * Wer angemeldet ist und was er darf — `GET /api/v1/auth/me`.
 *
 * **`locked` ist hier Pflicht**, weil der Server es immer schickt
 * (`auth.controller.ts`, `me()`); `gesperrtSeit` und `geraet` stehen nur in der
 * gesperrten Antwort. Im gesperrten Zustand gehen `roles` und `capabilities`
 * leer hinaus — eine gesperrte Sitzung soll keine Navigation bauen.
 *
 * Die Oberfläche leitet ihr Lesemodell hiervon ab und lockert allein `locked`
 * (ein älterer Server kannte das Feld nicht); alles andere kommt unverändert
 * aus diesem Vertrag.
 */
export const meResponseSchema = z
    .object({
    userId: z.string(),
    email: z.string(),
    displayName: z.string(),
    roles: z.array(z.string()),
    /** Alphabetisch sortiert, damit ein Vergleich zweier Antworten aussagekräftig ist. */
    capabilities: z.array(z.string()),
    locked: z.boolean(),
    /** ISO-8601, aus der Uhr des Servers. Nur in der gesperrten Antwort. */
    gesperrtSeit: z.string().optional(),
    /** Grober Gerätehinweis («Windows · Chrome»). Nur in der gesperrten Antwort. */
    geraet: z.string().optional(),
})
    .strict();
//# sourceMappingURL=auth.js.map